import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const usePackagers = () => {
  const [packagers, setPackagers] = useState(null);

  const load = useCallback(async () => {
    const res = await axios.get(`${API}/packagers`, { withCredentials: true });
    setPackagers(res.data);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const create = useCallback(async (payload) => {
    await axios.post(`${API}/packagers`, payload, { withCredentials: true });
    await load();
  }, [load]);

  return { packagers, create };
};
